module.exports = __webpack_public_path__ + "media/images/emblems/Nuerensdorf-blazon-e0b047882109d15a9c93aeb5f879aabe.svg";